module.exports = __webpack_public_path__ + "media/St 4-game console-hint.ffca72db.wav";